import { DeliveryData } from "../receivers/deliveryTypes/DeliveryData";
import FaceB2BDeliveryData from "../receivers/deliveryTypes/faceb2bReceiver/FaceB2BDeliveryData";

export function isFaceB2BDeliveryData(
  deliveryData: DeliveryData
): deliveryData is FaceB2BDeliveryData {
  return deliveryData !== null && "dire" in deliveryData;
}
